import script from "./EducationSkillView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EducationSkillView.vue?vue&type=script&lang=ts&setup=true"

import "./EducationSkillView.vue?vue&type=style&index=0&id=5cd3d2f8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd3d2f8"]])

export default __exports__